import type { RundownStatus } from '~shared/rundown/rundown'

import { updateRundown } from '@/entities/rundown/api/requests'

import { unsetRundownRunner } from '../../firestore'

/**
 * Changes to the rundown document, sent to the API.
 *
 * @remarks
 *   None of these write the rundown store. The Firestore listener in
 *   `rundown-session.ts` is the only writer, so a change shows up when its
 *   snapshot arrives. Errors propagate to the caller (the request already
 *   toasts), so an input can revert.
 */
export const rundownActions = {
  rename: (rundownId: string, name: string) =>
    updateRundown({ rundownId, payload: { name } }),

  setStatus: (rundownId: string, status: RundownStatus) =>
    updateRundown({ rundownId, payload: { status } }),

  setStartTime: (rundownId: string, startTime: Date) =>
    updateRundown({ rundownId, payload: { startTime } }),

  /**
   * Clears the start cue and unsets the runner, so the next start begins from
   * the top. Both requests go out together.
   */
  resetStartCue: (rundownId: string) =>
    Promise.all([
      updateRundown({ rundownId, payload: { startCueId: null } }),
      unsetRundownRunner(rundownId),
    ]),
}
